<div class="k-form-field k-form-field-with-icon sam-margin-right">
   <fa-icon class="sam-margin-left" [icon]="searchIcon"></fa-icon>
   <input
      fxFlex="1 1 auto"
      (input)="searchTextChanged($event.target.value)"
      (debouncedInput)="searchTextChangedDebounced($event.target.value)"
      [value]="searchValue$ | async"
      [placeholder]="searchText | translate"
      kendoTextBox
   />
   <fa-icon
      *ngIf="(searchValue$ | async)?.length > 0"
      class="clear-search-text-icon sam-center"
      [icon]="clearFilterIcon"
      (click)="clearSearchText()"
   >
   </fa-icon>
</div>
